<template>
  <div>
    <a :href="params.data.resume_url" target="_blank">
      <i>{{params.data.resume}}</i>
    </a>
  </div>
</template>

<script>
export default {};
</script>